module.exports = __webpack_public_path__ + "img/title-5.ac990d8b.png";